// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selectable-article {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 189px;
  word-break: break-word;
  border: 1px solid var(--color-black);
  border-radius: 26px;
  transition: background 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: auto;
  min-height: 305px;
  padding: 5px 12px;
  background: var(--default-background);
}
.item-selectable-article.selected {
  background: #F5FAFF;
  border: 2px solid var(--ion-color-primary);
}
.item-selectable-article.row {
  flex-direction: row;
}
.item-selectable-article.row ion-img {
  display: none;
}
.item-selectable-article.row .footer-block {
  width: auto;
}
.item-selectable-article .wrapper-item {
  width: 100%;
}
.item-selectable-article .footer-block {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 2px 5px;
}
.item-selectable-article .footer-block .width-item {
  width: 20px;
}
.item-selectable-article .footer-block .option-item {
  font-size: 16px;
  text-align: start;
  font-family: AppFont;
}
.item-selectable-article .footer-block .option-price {
  font-family: AppFontBold;
  color: var(--color-black);
  font-size: 16px;
  white-space: nowrap;
}
.item-selectable-article .footer-block .option-price.no-price {
  min-height: 12px;
  max-height: 12px;
}
.item-selectable-article .footer-block .added-item {
  display: flex;
  justify-content: flex-end;
}
.item-selectable-article .footer-block .added-item .selected-circle {
  border: 1px solid var(--color-black);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  background: var(--default-background);
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon {
  visibility: hidden;
  opacity: 0;
  font-size: 20px;
  transition: opacity 500ms ease-in-out;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon.selected {
  visibility: visible;
  opacity: 1;
}
.item-selectable-article .footer-block .added-item .selected-circle.selected {
  border: none;
  background: #D2E0F1;
}

.info-icon {
  position: absolute;
  height: 20px;
  width: 20px;
  top: 14px;
  right: 7px;
  z-index: 2;
}
@media (max-width: 992px) {
  .info-icon {
    height: 14px;
    width: 14px;
    top: 7px;
    right: 5px;
  }
}

.name {
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  min-height: 38px;
  color: var(--color-black);
  font-family: AppFontMedium;
  max-width: 180px;
}

.item-selectable-article-image {
  margin: 0 auto;
  height: 85px;
  max-width: 87%;
  object-fit: contain;
}
.item-selectable-article-image.default-img {
  object-fit: contain;
}

.quantity-selector {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 1px solid var(--color-black);
  border-radius: 26px;
  background: var(--default-background);
  margin: 5px auto 0;
  height: 38px;
  width: 65%;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  color: var(--color-black);
  font-size: 16px;
}
.quantity-selector .quantity-btn {
  width: 16px;
  height: 16px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.description {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
  color: var(--color-dark-gray);
  font-family: AppFont;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;AADF;AAEE;EACE,mBAAA;EACA,0CAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAEI;EACE,aAAA;AAAN;AAEI;EACE,WAAA;AAAN;AAIE;EACE,WAAA;AAFJ;AAIE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAFJ;AAGI;EACE,WAAA;AADN;AAGI;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;AADN;AAII;EACE,wBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAFN;AAGM;EACE,gBAAA;EACA,gBAAA;AADR;AAII;EACE,aAAA;EACA,yBAAA;AAFN;AAGM;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;AADR;AAEQ;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,qCAAA;AAAV;AACU;EACE,mBAAA;EACA,UAAA;AACZ;AAEQ;EACE,YAAA;EACA,mBAAA;AAAV;;AASA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AANF;AC1FE;ED0FF;IAQI,YAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;EAJF;AACF;;AAOA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;AAJF;;AAOA;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAJJ;AAKE;EACE,mBAAA;AAHJ;;AAYA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EAKA,YAAA;AAbF;AASE;EACE,eAAA;EACA,eAAA;AAPJ;AAUE;EACE,yBAAA;EACA,eAAA;AARJ;AAUE;EACE,WAAA;EACA,YAAA;AARJ;AASI;EACE,YAAA;AAPN;;AAWA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,oBAAA;AARF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.item-selectable-article {\n  position: relative;\n  margin: 0 auto;\n  flex-grow: 1;\n  min-height: 189px;\n  word-break: break-word;\n  border: 1px solid var(--color-black);\n  border-radius: 26px;\n  transition: background 200ms linear;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: auto;\n  min-height: 305px;\n  padding: 5px 12px;\n  background: var(--default-background);\n  &.selected {\n    background: #F5FAFF;\n    border: 2px solid var(--ion-color-primary);\n  }\n\n  &.row {\n    flex-direction: row;\n    ion-img {\n      display: none;\n    }\n    .footer-block {\n      width: auto;\n    }\n  }\n\n  .wrapper-item {\n    width: 100%;\n  }\n  .footer-block {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 2px 5px;\n    .width-item {\n      width: 20px;\n    }\n    .option-item {\n      font-size: 16px;\n      text-align: start;\n      font-family: AppFont;\n\n    }\n    .option-price {\n      font-family: AppFontBold;\n      color: var(--color-black);\n      font-size: 16px;\n      white-space: nowrap;\n      &.no-price {\n        min-height: 12px;\n        max-height: 12px;\n      }\n    }\n    .added-item {\n      display: flex;\n      justify-content: flex-end;\n      .selected-circle {\n        border: 1px solid var(--color-black);\n        border-radius: 50%;\n        width: 30px;\n        height: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: 5px;\n        background: var(--default-background);\n        ion-icon {\n          visibility: hidden;\n          opacity: 0;\n          font-size: 20px;\n          transition: opacity 500ms ease-in-out;\n          &.selected {\n            visibility: visible;\n            opacity: 1;\n          }\n        }\n        &.selected {\n          border: none;\n          background: #D2E0F1;\n        }\n\n      }\n    }\n\n  }\n}\n\n.info-icon {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  top: 14px;\n  right: 7px;\n  z-index: 2;\n  @include mobile {\n    height: 14px;\n    width: 14px;\n    top: 7px;\n    right: 5px;\n  }\n}\n\n.name {\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  min-height: 38px;\n  color: var(--color-black);\n  font-family: AppFontMedium;\n  max-width: 180px;\n}\n\n.item-selectable-article-image {\n    margin: 0 auto;\n    height: 85px;\n    max-width: 87%;\n    object-fit: contain;\n  &.default-img {\n    object-fit: contain;\n  }\n}\n\n// app-quantity-selector {\n//   filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n// }\n\n\n.quantity-selector {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  border: 1px solid var(--color-black);\n  border-radius: 26px;\n  background: var(--default-background);\n  margin: 5px auto 0;\n  height: 38px;\n  width: 65%;\n  ion-icon {\n    margin: 0px 6px;\n    cursor: pointer;\n  }\n  z-index:  999;\n  .quantity {\n    color: var(--color-black);\n    font-size: 16px;\n  }\n  .quantity-btn {\n    width: 16px;\n    height: 16px;\n    &.add-opacity {\n      opacity: 0.5;\n  }\n  }\n}\n.description {\n  font-size: 12px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  color: var(--color-dark-gray);\n  font-family: AppFont;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
